import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUmbrellaSecurity: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconUmbrellaSecurity"><Path d="M11.9992 2.75V4.75M11.9992 4.75C8.33421 4.75 5.09807 6.37454 3.16055 8.85412C1.96474 10.3845 3.36893 12.253 5.31108 12.253H18.6874C20.6295 12.253 22.0337 10.3845 20.8379 8.85412C18.9004 6.37454 15.6642 4.75 11.9992 4.75ZM11.9992 15.25V19.3267C11.9992 20.3889 11.1381 21.25 10.0759 21.25C9.15914 21.25 8.3698 20.6029 8.19 19.7039L7.99922 18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconUmbrellaSecurity;
